import { AdminMembersReportSurveysTableRowFragment$key } from "@/admin/insights/member-reports/tabs/contents/__generated__/AdminMembersReportSurveysTableRowFragment.graphql"
import WebFormQuestionResponseTableField from "@/web-form/table/WebFormQuestionResponseTableField"
import WebFormQuestionTableField from "@/web-form/table/WebFormQuestionTableField"
import WebFormQuestionTypeTableField from "@/web-form/table/WebFormQuestionTypeTableField"
import makeUseStyles from "@assets/style/util/makeUseStyles"
import { DiscoTable } from "@disco-ui"
import { TableCell } from "@material-ui/core"
import { Skeleton } from "@material-ui/lab"
import classNames from "classnames"
import { graphql, useFragment } from "react-relay"

interface Props {
  webFormQuestionKey: AdminMembersReportSurveysTableRowFragment$key
}

function AdminMembersReportSurveysTableRow({ webFormQuestionKey }: Props) {
  const classes = useStyles()
  const webFormQuestion = useFragment<AdminMembersReportSurveysTableRowFragment$key>(
    graphql`
      fragment AdminMembersReportSurveysTableRowFragment on WebFormQuestion
      @argumentDefinitions(
        organizationMembershipId: { type: "ID!" }
        contentUsageId: { type: "ID!" }
      ) {
        ...WebFormQuestionTypeTableFieldFragment
        ...WebFormQuestionTableFieldFragment
        ...WebFormQuestionResponseTableFieldFragment
          @arguments(
            organizationMembershipId: $organizationMembershipId
            contentUsageId: $contentUsageId
          )
      }
    `,
    webFormQuestionKey
  )

  return (
    <DiscoTable.Row>
      {/* Type */}
      <TableCell className={classNames(classes.tableCell, classes.typeTableCell)}>
        <WebFormQuestionTypeTableField webFormQuestionKey={webFormQuestion} />
      </TableCell>

      {/* Question */}
      <TableCell className={classes.tableCell}>
        <WebFormQuestionTableField
          testid={`AdminMembersReportSurveysTableRow.rich-editor`}
          webFormQuestionKey={webFormQuestion}
        />
      </TableCell>

      {/* Response */}
      <TableCell className={classes.tableCell}>
        <WebFormQuestionResponseTableField webFormQuestionKey={webFormQuestion} />
      </TableCell>
    </DiscoTable.Row>
  )
}

const useStyles = makeUseStyles((theme) => ({
  tableCell: {
    verticalAlign: "top",
  },
  typeTableCell: {
    paddingTop: `${theme.spacing(1.75)}px !important`,
    paddingLeft: `${theme.spacing(1.5)}px !important`,
  },
}))

export function AdminMembersReportSurveysTableRowSkeleton() {
  return (
    <DiscoTable.Row>
      <TableCell>
        <Skeleton variant={"rect"} />
      </TableCell>
      <TableCell>
        <Skeleton variant={"rect"} />
      </TableCell>
      <TableCell>
        <Skeleton variant={"rect"} />
      </TableCell>
    </DiscoTable.Row>
  )
}

export default AdminMembersReportSurveysTableRow
